import { Tab } from '@components'
import { Fragment, useEffect, useMemo } from 'react'
import AdminDefaultSeoForm from '../seoForm'
import { useSelector } from 'react-redux'
import { fetchByKey } from '../fetch'
import AdminFooterForm from '../components/footer'
import { useSearchParams } from 'react-router-dom'

const AdminSeoSetting = () => {
  const [searchParams] = useSearchParams()
  const tab = searchParams.get('tab')

  const { data: homeSeo } = useSelector((state: any) => state.homeSeo)
  const { data: loginSeo } = useSelector((state: any) => state.loginSeo)
  const { data: registerSeo } = useSelector((state: any) => state.registerSeo)
  const { data: footer } = useSelector((state: any) => state.footer)

  const seoDataMap = useMemo(
    () => ({
      homeSeo,
      loginSeo,
      registerSeo,
      footer,
    }),
    [homeSeo, loginSeo, registerSeo, footer],
  )

  useEffect(() => {
    const data = seoDataMap[tab as keyof typeof seoDataMap]
    if (data && !data.id) {
      fetchByKey(tab!)
    }
  }, [tab, seoDataMap])

  const onChangeKey = (key: string) => {
    const data = seoDataMap[key as keyof typeof seoDataMap]
    if (data && !data.id) {
      fetchByKey(key)
    }
  }

  const tabItems = [
    {
      key: 'homeSeo',
      label: 'Home',
      render: (
        <AdminDefaultSeoForm
          title="Home Seo"
          pageKey="homeSeo"
          data={homeSeo}
        />
      ),
    },
    {
      key: 'loginSeo',
      label: 'Login',
      render: (
        <AdminDefaultSeoForm
          title="Login Seo"
          pageKey="loginSeo"
          data={loginSeo}
        />
      ),
    },
    {
      key: 'registerSeo',
      label: 'Register',
      render: (
        <AdminDefaultSeoForm
          title="Register Seo"
          pageKey="registerSeo"
          data={registerSeo}
        />
      ),
    },
    {
      key: 'footer',
      label: 'Footer',
      render: <AdminFooterForm pageKey="footer" data={footer} />,
    },
  ]

  return (
    <Fragment>
      <Tab
        items={tabItems}
        activeTab="homeSeo"
        onChange={onChangeKey}
        hasBg
        title="Seo Settings"
      />
    </Fragment>
  )
}

export default AdminSeoSetting
